export const formDialogSelector = (state) => state.ui.formDialog;

export const alertDialogSelector = (state) => state.ui.alertDialog;

export const pageTitleSelector = (state) => state.ui.pageTitle;

export const drawerSelector = (state) => state.ui.drawer;

export const loadingSelector = (state) => state.ui.loading;
